import React from "react";
import styles from "./About.module.css";
import Banner from "./Banner/Banner";
import OurMissionImg1 from "../../assets/images/OurMissionImg1.png";
import OurMissionImg2 from "../../assets/images/OurMissionImg2.png";
import ImparcStorypic from "../../assets/images/imparcStorypic.png";
import GovernanceIcon1 from "../../assets/images/governanceIcon1.svg";
import GovernanceIcon2 from "../../assets/images/governanceIcon2.svg";
import GovernanceIcon3 from "../../assets/images/governanceIcon3.svg";
import GovernanceIcon4 from "../../assets/images/governanceIcon4.svg";
import ActivitiesImg1 from "../../assets/images/activitiesImg1.png";
import ActivitiesImg2 from "../../assets/images/activitiesImg2.png";
import ActivitiesImg3 from "../../assets/images/activitiesImg3.png";
import ProcessImg1 from "../../assets/images/AppointmentProcessImg1.png";
import ProcessImg2 from "../../assets/images/AppointmentProcessImg2.png";
import ProcessImg3 from "../../assets/images/AppointmentProcessImg3.png";
import ProcessImg4 from "../../assets/images/AppointmentProcessImg4.png";

const AboutPage = () => {
  return (
    <main className={styles.aboutPage}>
      <Banner />

      <div className={styles.aboutusPage}>
        {/* Vision & Mission */}
        <div className={styles.container}>
          <section className={styles.visionMission}>
            <h3>
              Vision <span>& Mission</span>
            </h3>
            <p className={styles.subheading}>
              Driving transformative research and innovation through
              collaborative excellence
            </p>
            <div className={styles.cards}>
              <div className={styles.card}>
                <div className={styles.image}>
                  <img src={OurMissionImg1} alt="Our Vision" />
                </div>
                <h4>Our Vision</h4>
                <p>
                  To be the premier platform for advancing research excellence, fostering innovation, and creating meaningful connections between researchers, mentors, and industry leaders worldwide.
                </p>
              </div>
              <div className={styles.card}>
                <div className={styles.image}>
                  <img src={OurMissionImg2} alt="Our Mission" />
                </div>
                <h4>Our Mission</h4>
                <p>
                  To empower researchers through strategic mentorship, collaborative initiatives, and innovative programs that bridge the gap between academic excellence and real-world impact.
                </p>
              </div>
            </div>
          </section>

          {/* Story */}
          <section className={styles.story}>
            <div className={styles.image}>
              <img src={ImparcStorypic} alt="IMPARC Story" />
            </div>
            <div className={styles.details}>
              <h3>
                IMPARC  <span>Story </span>
              </h3>
              <p>Our Journey of Innovation, Collaboration & Impact</p>
              <h4>Background & Origins</h4>
              <p>
                IMPARC was founded with the vision of creating a transformative academic platform that bridges the gap between research, mentorship, and real-world application. Born from the growing need for structured academic support systems, IMPARC provides researchers and institutions with an ecosystem designed for excellence and long-term growth.
              </p>
              <ul>
                <li>
                  <h5>Ignited Minds Partnership</h5>
                  Powered by Ignited Minds Edutech Pvt. Ltd., IMPARC integrates academic innovation with structured governance and global outreach.
                </li>
                <li>
                  <h5>MentorsGate Integration </h5>
                  With the integration of MentorsGate, IMPARC strengthens its mentorship ecosystem, enabling guided academic progression and meaningful professional networking opportunities for researchers across disciplines.
                </li>
              </ul>
            </div>
          </section>

          {/* Governance */}
          <section className={styles.governance}>
            <h3>
              Governance <span>& Committees</span>
            </h3>
            <p className={styles.subheading}>
              Structured leadership ensuring excellence in all our initiatives.
              <br /><br />
              IMPARC operates through a transparent and well-defined governance structure that promotes accountability, strategic planning, and academic integrity.
            </p>
            <div className={styles.cards}>
              <div className={styles.card}>
                <div className={styles.icon}>
                  <img src={GovernanceIcon1} alt="GAC" />
                </div>
                <h6> GAC - <span>Governance Advisory Committee</span>
                </h6>
                <p>
                  Provides strategic direction, policy oversight, and long-term vision alignment.
                </p>
              </div>
              <div className={`${styles.card} ${styles.blueborder}`}>
                <div className={styles.icon}>
                  <img src={GovernanceIcon2} alt="CAC" />
                </div>
                <h6>CEC - <span> Core Executive Committee</span></h6>
                <p>Ensures smooth execution of programs, inter-committee coordination, and operational excellence.</p>
              </div>
              <div className={styles.card}>
                <div className={styles.icon}>
                  <img src={GovernanceIcon3} alt="Advisors" />
                </div>
                <h6>Advisors - <span>Strategic Advisory Board</span></h6>
                <p>Offers domain expertise, research insights, and global perspectives to guide institutional initiatives.</p>
              </div>
              <div className={`${styles.card} ${styles.blueborder}`}>
                <div className={styles.icon}>
                  <img src={GovernanceIcon4} alt="Coordinators" />
                </div>
                <h6>Coordinators - <span>Program Coordinators</span></h6>
                <p>Lead and manage program implementation, mentor engagement, and participant coordination.</p>
              </div>
            </div>
          </section>

          {/* Activities */}
        </div>
        <section className={styles.activities}>
          <div className={styles.container}>
            <h3>
              Activities <span>& Initiatives</span>
            </h3>
            <p className={styles.subheading}>
              IMPARC advances research excellence, academic leadership, and global collaboration through structured flagship initiatives designed to create measurable and sustainable academic impact.
            </p>
            <div className={styles.cards}>
              <article className={styles.card}>
                <figure>
                  <img src={ActivitiesImg1} alt="IMPARC Knowledge Series" />
                </figure>
                <h4>IMPARC <br/>
                Knowledge Series Program</h4>
                <p>
                 A premier academic forum featuring expert lectures, panel discussions, and interdisciplinary conferences that promote research dissemination, policy dialogue, and global scholarly engagement.
                </p>
                
              </article>
              <article className={`${styles.card} ${styles.card2}`}>
                <figure>
                  <img src={ActivitiesImg2} alt="IMPARC Academic Advancement Program (IAAP)" />
                </figure>
                <h4>IMPARC <br/>Academic Advancement Program <br/> (IAAP)</h4>
                <p>
                  A structured professional development initiative offering publication mentoring, research methodology guidance, grant proposal support, and academic profile enhancement to strengthen research outcomes and career advancement.
                </p>
                
              </article>
              <article className={`${styles.card} ${styles.card3}`}>
                <figure>
                  <img src={ActivitiesImg3} alt="Ignited Minds Today & IM-GAEA (Magazine & Global Academic Excellence Awards)" />
                </figure>
                <h4>Ignited Minds Today & <br/>IM-GAEA (Magazine & Global Academic Excellence Awards)</h4>
                <p>A combined knowledge and recognition platform that promotes thought leadership through a quarterly academic & policy magazine while honoring excellence in research, leadership, mentorship, and institutional innovation through the Ignited Minds Global Academic Excellence Awards.</p>
              </article>
            </div>
          </div>
        </section>
        <div className={styles.container}>
          {/* Appointment Process */}
          <section className={styles.appointment}>
            <h3>
              Appointment <span>& Nomination Process</span>
            </h3>
            <p className={styles.subheading}>
             A transparent, merit-based, and structured evaluation framework ensuring credibility, academic integrity, and leadership excellence across all IMPARC initiatives.
            </p>
            <div className={styles.steps}>
              <div className={styles.step}>
                <figure>
                  <img src={ProcessImg1} alt="Application" />
                </figure>
                <h4>Application</h4>
                <p>Submission of a detailed academic profile, research portfolio, and supporting credentials aligned with the applied role or nomination category.</p>
              </div>
              <div className={styles.step}>
                <figure>
                  <img src={ProcessImg2} alt="Review" />
                </figure>
                <h4>Review</h4>
                <p>Comprehensive evaluation by an expert panel, including academic merit assessment, contribution analysis, and background verification.</p>
              </div>
              <div className={styles.step}>
                <figure>
                  <img src={ProcessImg3} alt="Interview" />
                </figure>
                <h4>Interview</h4>
                <p>Structured interaction with the review committee to assess domain expertise, vision alignment, and potential institutional impact.</p>
              </div>
              <div className={styles.step}>
                <figure>
                  <img src={ProcessImg4} alt="Selection" />
                </figure>
                <h4>Selection & Onboarding</h4>
                <p>Final approval based on merit and strategic fit, followed by formal appointment, orientation, and integration into the IMPARC ecosystem.</p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </main>
  );
};

export default AboutPage;
